/**
 * Event targets are not always Elements (e.g. Text inside a label). Several UI libraries call
 * `event.target.closest(...)` and throw. Element defines `closest`; Node/Text do not.
 * Delegate from any node to its element ancestor so hover / pointer paths stay safe.
 */
const np = Node.prototype as Node & {
  closest?: (this: Node, selector: string) => Element | null;
};

if (typeof np.closest !== "function") {
  np.closest = function closest(this: Node, selector: string): Element | null {
    const el =
      this.nodeType === Node.ELEMENT_NODE
        ? (this as Element)
        : this.parentElement;
    if (!el) return null;
    const fn = Element.prototype.closest;
    if (typeof fn !== "function") return null;
    return fn.call(el, selector);
  };
}

export {};
